module.exports = __webpack_public_path__ + "img/discover_card_icon.ccaa7559.png";